import api from './api'

export const googleReviewService = {
  getConfig: () => api.get('/google-reviews/config'),
  saveConfig: (data: { apiKey: string; placeId: string }) => api.put('/google-reviews/config', data),
  getBusinessInfo: () => api.get('/google-reviews/business'),
  getSummary: () => api.get('/google-reviews/summary'),
  getReviews: (params?: { rating?: number; search?: string; sort?: string; page?: number; limit?: number }) =>
    api.get('/google-reviews', { params }),
  getAllData: () => api.get('/google-reviews/all'),
}
